import React from "react";
import { TableList, Td } from "static/coreStyles/table.styled";
import { UTCtoLocalDateTime } from "utility/dateTimeUtils";

const MessagesList = ({ data }) => {
    if (!data.id) return null;
    return (
        <TableList>
            {" "}
            <Td width="15%">{data.senderName}</Td>{" "}
            <Td width="15%">{data.senderPhoneNumber}</Td>
            <Td width="15%" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <span>{UTCtoLocalDateTime(data.messageTime).date}</span>
                <em>{UTCtoLocalDateTime(data.messageTime).time}</em>
            </Td>
            <Td width="15%">{data.messageType}</Td>
            <Td width="35%">{data.messageContent}</Td>
            <Td width="10%">{data.messageFlow}</Td>
        </TableList>
    );
};

export default MessagesList;
